import "./selectableslideritem.scss"
import React from "react";

export interface ISelectableSliderItem {
    image:string
    title:string
    activate:string
    setActivate: React.Dispatch<React.SetStateAction<string>>
    id:number
}

const SelectableSliderItem = ({image,title,id,activate,setActivate}:ISelectableSliderItem) => {
    return (
        <div onClick={() => {
            setActivate(`item${id}`);
        }} className={activate === `item${id}` ? "Selectable-Slider-Item active" : "Selectable-Slider-Item"}>
            <img src={image} className="img-fluid" alt=""/>
            <span>{title}</span>
        </div>
    );
}

export default SelectableSliderItem;